module.exports = __webpack_public_path__ + "img/msg.4974cdb0.jpg";